import React from 'react';

import { formatDate, formatTime, parsePrice } from '../../../../utils/utils';

const getStatus = (status: string, type: string) => {
  const txnStatus = status && status.toLowerCase();
  const txnType = type && type.toLowerCase();
  if (txnStatus === 'success') {
    return txnType === 'debit' ? 'Transferred' : txnType === 'credit' ? 'Deposited' : '---';
  } else if (txnStatus === 'failure') {
    return 'failed';
  }
  return status.toLowerCase();
};

const TxnDate = (props: any) => (
  <div className="data-column small">
    <p className="date">{formatDate(props.date)}</p>
    <p className="date font-light-grey mt8">{formatTime(props.date)}</p>
  </div>
);

const TxnDescription = (props: any) => (
  <div className="data-column small">
    <p>{props.description || '---'}</p>
  </div>
);

const TxnStatus = (props: any) => {
  const { status = '', transactionType } = props;
  let txnStatus = getStatus(status, transactionType);
  return (
    <div className="data-column small">
      <p className={`text-capitalize ${status.toLowerCase()}`}>{txnStatus || '---'}</p>
    </div>
  );
};

const TxnAmount = (props: any) => {
  const price = parsePrice({ price: props.amount });
  const txnType = props.transactionType && props.transactionType.toLowerCase();
  return (
    <div className="data-column small flex">
      <p>{`${txnType === 'debit' ? `-` : `+`} ${price}`}</p>
    </div>
  );
};

const TxnOpenAmount = (props: any) => (
  <div className="data-column small flex">
    <p>{parsePrice({ price: props.openingBalance })}</p>
  </div>
);

const TxnCloseAmount = (props: any) => (
  <div className="data-column small flex">
    <p>{parsePrice({ price: props.closingBalance })}</p>
  </div>
);

const TxnMessage = (props: any) => (
  <div
    className={`text-center small wfull message mt16 ${
      props.status === 'SUCCESS' ? 'none' : props.status && props.status.toLowerCase()
    }`}
  >
    <p className="data-column small">
      {props.status === 'PENDING' ? 'Payment Processing. Please wait for 15 minutes.' : props.statusRemarks}
    </p>
    <div className={`absolute t0 l0 wfull hfull ${props.status.toLowerCase()}`}></div>
  </div>
);

interface headingObj {
  heading?: string;
}

export const dataMapping = (headingProps: headingObj) => [
  {
    name: TxnDate,
    attr: ['date'],
    heading: 'Date & Time',
  },
  {
    name: TxnDescription,
    attr: ['description'],
    heading: 'Transaction',
  },
  {
    name: TxnAmount,
    attr: ['amount', 'transactionType'],
    heading: 'Amount',
  },
  {
    name: TxnOpenAmount,
    attr: ['openingBalance'],
    heading: 'Opening Bal.',
  },
  {
    name: TxnCloseAmount,
    attr: ['closingBalance'],
    heading: 'Closing Bal.',
  },
  {
    name: TxnStatus,
    attr: ['status', 'transactionType'],
    heading: 'Status',
  },
  {
    name: TxnMessage,
    attr: ['status', 'statusRemarks'],
  },
];
